"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var mask = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;

var IEmail =
/*#__PURE__*/
function () {
  function IEmail(value) {
    (0, _classCallCheck2["default"])(this, IEmail);
    var data,
        proto = Object.getPrototypeOf(this);

    if (!proto._mask) {
      proto._mask = mask;
    }

    this.value = '';
    this.name = '';
    this.domain = '';

    if (!value) {
      return this;
    }

    if (value instanceof IEmail) {
      this.value = value.value;
      this.name = value.name;
      this.domain = value.domain;
    } else {
      value = String(value).trim().toLowerCase();

      if (this._mask.test(value)) {
        data = value.split('@');
        this.value = value;
        this.name = data[0] || '';
        this.domain = data[1] || '';
      }
    }

    return this;
  }

  (0, _createClass2["default"])(IEmail, [{
    key: "validate",
    value: function validate() {
      return this._mask.test(this.value);
    }
    /**
     * @param {string} value
     * @return {boolean}
     */

  }, {
    key: "is",
    value: function is(value) {
      return this.value === new IEmail(value).value;
    }
    /**
     * @return {string}
     */

  }, {
    key: "toString",
    value: function toString() {
      return this.value;
    }
  }, {
    key: "isDefault",
    value: function isDefault() {
      console.warn('IEmail prototype.isDefault() is deprecated.');
      return false;
    }
    /**
     * @return {string}
     */

  }, {
    key: "toHtml",
    value: function toHtml() {
      console.warn('IEmail prototype.toHtml() is deprecated. Use .toString().');
      return this.toString();
    }
  }]);
  return IEmail;
}();

var _default = IEmail;
exports["default"] = _default;